<template>
<div class="full-width">
	<div class="map"></div>
</div>
</template>

<script>
export default {
	props: {
		lat: {
			type: Number,
			default: 0
		},
		lng: {
			type: Number,
			default: 0
		}
	},
	mounted: function() {
		this.setupMap();
	},
	updated: function() {
		this.setupMap();
	},
	methods: {
		setupMap: function() {
			var mapEl = this.$el.querySelector('.map');
			var geocoder = new google.maps.Geocoder();
			var that = this;
			var lat = this.lat;
			var lng = this.lng;
				// create map
				var map = new google.maps.Map(mapEl, {
					zoom: 17,
					center: new google.maps.LatLng(lat, lng),
					mapTypeId: google.maps.MapTypeId.ROADMAP
				});

				// add marker
				var marker = new google.maps.Marker({
					position: new google.maps.LatLng(lat, lng),
					map: map
				});
			}

	}
}
</script>



// WEBPACK FOOTER //
// src/components/GoogleMap.vue